export const BenHttp = {
  request(url: string, data = {} as any, { method = 'POST' as 'GET' | 'POST', timeout = 20000 } = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      let requestUrl = url
      if (method === 'GET' && data) {
        const params = new URLSearchParams()
        Object.entries(data).forEach(([key, value]) => {
          params.append(key, String(value))
        })
        requestUrl += `?${params.toString()}`
      }
      xhr.open(method, requestUrl, true)
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      const timeoutTimer = setTimeout(() => {
        xhr.abort()
        reject('time out')
      }, timeout)
      xhr.onload = () => {
        clearTimeout(timeoutTimer)
        if (xhr.status >= 200 && xhr.status < 300) {
          let response = xhr.responseText
          try {
            response = JSON.parse(xhr.responseText)
          } catch { }
          resolve(response)
        } else {
          reject('请求失败 ' + requestUrl)
        }
      }
      xhr.onerror = () => {
        clearTimeout(timeoutTimer)
        reject('请求失败 ' + requestUrl)
      }
      xhr.onabort = () => {
        clearTimeout(timeoutTimer)
      }
      if (method === 'POST') {
        xhr.send(JSON.stringify(data))
      } else {
        xhr.send()
      }
    })
  },
}
